import type { BoosterRedeemType } from "../utils/redeemPayload"

export const REDEEM_UI = {
  profileTitle: "Печать пробуждения",
  profileSubtitle: "Оживи карту или дар стихий",
  screenTitle: "Печать пробуждения",
  cameraHint: "Наведи на печать",
  cardSuccessTitle: "Печать пробуждена!",
  boosterSuccessTitle: "Дар принят!",
  cardErrorFallback: "Не удалось пробудить печать",
  boosterErrorFallback: "Не удалось принять дар",
} as const

export function boosterGiftBody(
  kind: BoosterRedeemType,
  amount?: number | null
): string {
  const suffix =
    amount != null && Number.isFinite(amount) && amount > 0
      ? ` (+${amount})`
      : ""

  switch (kind) {
    case "coins":
      return `Монеты вошли в казну${suffix}`
    case "chakra":
      return `Чакра вошла в тебя${suffix}`
    case "energy":
      return `Энергия наполнила тебя${suffix}`
    case "shard-dust":
      return `Пыль осколков осела в руках${suffix}`
    case "style-token":
      return `Токен стиля принят${suffix}`
    case "fuse":
      return `Усилитель слияния готов${suffix}`
    default:
      return `Дар стихий принят${suffix}`
  }
}
